import { post } from '@/request/racmBlockRequest';

let basePath = '/port/proposal';

export function add(params) {
  return post(basePath + '/add', params);
}
